export default "__VITE_ASSET__C2Wc0Yb5__"